import { BsSendFill } from 'react-icons/bs';
import { useState } from 'react';
import { TextField, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import WhatIfNoteEditService from '../service/WhatIfNoteEditService';
import WhatIfNoteEditDto from '../dto/WhatIfNoteEditDto';

function NoteItemInput(props) {
	const { noteItemKey, whatIf } = props;
	const { t } = useTranslation('whatIf');
	const [messageText, setMessageText] = useState('');
	const [loading, setLoading] = useState(false);
	const [saveFailed, setSaveFailed] = useState(false);

	function onInputChange(ev) {
		setMessageText(ev.target.value);
		setSaveFailed(false);
	}

	const sendTextMessage = () => {
		if (messageText.trim().length === 0) return;
		setLoading(true);
		setSaveFailed(false);
		WhatIfNoteEditService.save(
			new WhatIfNoteEditDto().setup({
				noteItemKey,
				whatIf,
				creator: null,
				created: new Date(),
				text: messageText
			})
		)
			.then(resp => {
				if (!resp.successful) throw new Error('Note save failed');
				setMessageText('');
				if (typeof props.onChange === 'function') return props.onChange(resp);
				return null;
			})
			.catch(() => {
				setSaveFailed(true);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<div className="w-full bg-white flex flex-row gap-6">
			<TextField
				className="flex-1"
				multiline
				variant="outlined"
				placeholder={t('noteCommentPlaceholder')}
				label={t('noteCommentLabel')}
				onChange={onInputChange}
				value={messageText}
				error={saveFailed}
				helperText={saveFailed ? t('noteSaveFailed') : ''}
			/>
			<div className="flex items-end justify-center pb-4">
				<IconButton color="primary" onClick={sendTextMessage} disabled={loading || messageText.trim().length === 0} aria-label={t('sendNote')}>
					<BsSendFill size="20px" />
				</IconButton>
			</div>
		</div>
	);
}
export default NoteItemInput;
